export default __webpack_public_path__ + "static/media/ic_delete.3270f2c9.svg";